import parse from 'html-react-parser';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { getAllAddresses, selectLocations } from '../../redux/AddressSlice';

const AddressViewer = (props: { street: string | null, zipCode: string | null, poBox: string | null, state: string, city: string | null}) => {

    const dispatch = useAppDispatch();
    const locationSelector = useAppSelector(selectLocations);
    const [address, setAddress] = useState("");

    const [stateValue, setStateValue] = React.useState<string>('');

    useEffect(() => {

        const stateLocation = locationSelector.find((stateNode: { children: any[]; }) => stateNode.children
            .some(countyNode => countyNode
                .children.some((cityNode: { name: string; }) => cityNode.name == props.city)));

        if (stateLocation !== undefined) {
            setStateValue(stateLocation.name);
        }
        else {
            setStateValue("");
        }
 
        var addressFormatted = ((props.poBox && props.poBox.trim().length > 0) ? props.poBox.trim() + "<br/>" : "") +
                               ((props.street && props.street.trim().length > 0) ? props.street.trim() + "<br/>" : "") +
                               ((props.city && props.city.trim().length > 0) ? props.city.trim() + ", " : "") +
                                stateValue + " " +
                               ((props.zipCode && props.zipCode.trim().length > 0) ? props.zipCode.trim() + "." : "");

        setAddress(addressFormatted);

    }, [props]);



    React.useEffect(() => {
        if (locationSelector === null ||
            (locationSelector !== null && locationSelector.length === 0)
        ) {
            dispatch(getAllAddresses());
        }
    }, []);

    return (
        <React.Fragment>
            <Label >{parse(address)}</Label>
        </React.Fragment>
    );
}

export default AddressViewer;